import React from 'react';
import { IOldIconProps } from './type';

const DeliveryFilled: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="path-1-outside-1"
        maskUnits="userSpaceOnUse"
        x="0.5"
        y="3"
        width="32"
        height="23"
        fill="black"
      >
        <rect fill="white" x="0.5" y="3" width="32" height="23" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3667 5H4.36667C3.33574 5 2.5 5.83573 2.5 6.86666V21.8C2.5 22.8309 3.33574 23.6667 4.36667 23.6667H11.9578H18.3667C18.5278 23.6667 18.6841 23.6463 18.8332 23.6079C18.9824 23.6463 19.1388 23.6667 19.3 23.6667H28.6333C29.6643 23.6667 30.5 22.831 30.5 21.8001V15.2667H27.8854L25.6308 9.64469C25.2404 8.67136 24.2972 8.0334 23.2485 8.0334H22.1C21.3645 8.0334 20.7013 8.34275 20.2333 8.83843V6.86667C20.2333 5.83574 19.3976 5 18.3667 5ZM20.9333 15.2667H26.3771L24.3314 10.1658C24.1539 9.72338 23.7252 9.4334 23.2485 9.4334H22.1C21.4557 9.4334 20.9333 9.95573 20.9333 10.6001V15.2667Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3667 5H4.36667C3.33574 5 2.5 5.83573 2.5 6.86666V21.8C2.5 22.8309 3.33574 23.6667 4.36667 23.6667H11.9578H18.3667C18.5278 23.6667 18.6841 23.6463 18.8332 23.6079C18.9824 23.6463 19.1388 23.6667 19.3 23.6667H28.6333C29.6643 23.6667 30.5 22.831 30.5 21.8001V15.2667H27.8854L25.6308 9.64469C25.2404 8.67136 24.2972 8.0334 23.2485 8.0334H22.1C21.3645 8.0334 20.7013 8.34275 20.2333 8.83843V6.86667C20.2333 5.83574 19.3976 5 18.3667 5ZM20.9333 15.2667H26.3771L24.3314 10.1658C24.1539 9.72338 23.7252 9.4334 23.2485 9.4334H22.1C21.4557 9.4334 20.9333 9.95573 20.9333 10.6001V15.2667Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6667 26.2333C26.2131 26.2333 27.4667 24.9797 27.4667 23.4333C27.4667 21.8869 26.2131 20.6333 24.6667 20.6333C23.1203 20.6333 21.8667 21.8869 21.8667 23.4333C21.8667 24.9797 23.1203 26.2333 24.6667 26.2333ZM8.8 26.2334C10.3464 26.2334 11.6 24.9798 11.6 23.4334C11.6 21.887 10.3464 20.6334 8.8 20.6334C7.2536 20.6334 6 21.887 6 23.4334C6 24.9798 7.2536 26.2334 8.8 26.2334Z"
        fill={color}
      />
      <path
        d="M26.7667 23.4333C26.7667 24.5931 25.8265 25.5333 24.6667 25.5333V26.9333C26.5997 26.9333 28.1667 25.3663 28.1667 23.4333H26.7667ZM24.6667 21.3333C25.8265 21.3333 26.7667 22.2735 26.7667 23.4333H28.1667C28.1667 21.5003 26.5997 19.9333 24.6667 19.9333V21.3333ZM22.5667 23.4333C22.5667 22.2735 23.5069 21.3333 24.6667 21.3333V19.9333C22.7337 19.9333 21.1667 21.5003 21.1667 23.4333H22.5667ZM24.6667 25.5333C23.5069 25.5333 22.5667 24.5931 22.5667 23.4333H21.1667C21.1667 25.3663 22.7337 26.9333 24.6667 26.9333V25.5333ZM10.9 23.4334C10.9 24.5932 9.9598 25.5334 8.8 25.5334V26.9334C10.733 26.9334 12.3 25.3664 12.3 23.4334H10.9ZM8.8 21.3334C9.9598 21.3334 10.9 22.2736 10.9 23.4334H12.3C12.3 21.5004 10.733 19.9334 8.8 19.9334V21.3334ZM6.7 23.4334C6.7 22.2736 7.6402 21.3334 8.8 21.3334V19.9334C6.867 19.9334 5.3 21.5004 5.3 23.4334H6.7ZM8.8 25.5334C7.6402 25.5334 6.7 24.5932 6.7 23.4334H5.3C5.3 25.3664 6.867 26.9334 8.8 26.9334V25.5334Z"
        fill="white"
      />
    </svg>
  );
};

export default DeliveryFilled;
